export default class Newsletter {
    setupForm(form, source = null) {
        if(typeof form === "undefined") {
            console.error('form undefined, form cannot be initialized for marketing automation');
        }

        const submitButton = form.querySelector('button[type=submit]');

        if(!submitButton) {
            return false
        }

        const handleSubmit = this.handleSubmit;

        if(!window.Shopify.reCaptchaKeyTheme) {
            console.warn('reCaptchaKeyTheme undefined, form cannot be initialized in ajax for marketing automation');
        }

        submitButton.addEventListener('click', e => {
            e.preventDefault();

            const checkboxConsent = form.querySelector('.js-newsletter-checkbox-consent')
            if(!checkboxConsent.checked) {
                form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                    error: {
                        code: SUBSCRIPTION_NO_CONSENT
                    }
                })));
                return;
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(window.Shopify.reCaptchaKeyTheme, {action: 'submit'}).then(async (token) => {
                    console.log('🤖 Human after all !')
                    await handleSubmit(form);
                });
            });
        })
    }

    async handleSubmit(form) {
        const email = form.querySelector('input[name="contact[email]"]').value;
        const language = form.querySelector('input[name="contact[locale]"]').value;
        const source = form.querySelector('input[name="contact[source]"]').value;
        const key = form.querySelector('input[name="key"]').value;

        if(!Newsletter.validateEmail(email)) {
            form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                error: {
                    code: SUBSCRIPTION_EMAIL_NOT_VALID
                }
            })));
            return;
        }

        if(!Newsletter.validateEmail(email)) {
            form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                error: {
                    code: SUBSCRIPTION_EMAIL_NOT_VALID
                }
            })));
            return;
        }

        const formData = new FormData(form); // formElement étant ton formulaire HTML

        await fetch('https://w3app-customer-api.herokuapp.com/v3/customer/subscribe', {
            method: 'POST',
            headers: {
                'X-Shopify-shop-domain': Shopify.shop,
                'Authorization': 'Bearer ' + key
            },
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if(data.status === "success") {
                    form.dispatchEvent(new CustomEvent('subscription:success', generateEventDetail({
                        error: {
                            code: SUBSCRIPTION_SUCCESS
                        }
                    })));
                } else if(data.status.toLowerCase() === "already_accepts_marketing") {
                    form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                        error: {
                            code: SUBSCRIPTION_EMAIL_EXISTS
                        }
                    })));
                } else if(data.status.toLowerCase() === "update_accepts_marketing") {
                    form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                        error: {
                            code: SUBSCRIPTION_EMAIL_EXISTS
                        }
                    })));
                } else {
                    form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                        error: {
                            code: SUBSCRIPTION_FATAL_ERROR
                        }
                    })));
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    static validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}

export const SUBSCRIPTION_EMAIL_NOT_VALID = -1;
export const SUBSCRIPTION_EMAIL_EXISTS    = -2;
export const SUBSCRIPTION_FATAL_ERROR     = -3;
export const SUBSCRIPTION_NO_CONSENT      = -4;
export const SUBSCRIPTION_SUCCESS         =  1;

const generateEventDetail = (object) => ({ detail : object });
